module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    class: ['university', _vm.minified ? 'is-minified' : '']
  }, [(_vm.minified) ? _c('div', {
    on: {
      "click": _vm.expand
    }
  }, [_vm._v(_vm._s(_vm.$t('university.minified')))]) : _c('div', [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.headline)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }), _vm._v(" "), (!_vm.onboarding) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('text.search')
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('action', {
    attrs: {
      "icon": "cancel",
      "color": "transparent"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }), _vm._v(" "), (_vm.loaded) ? _c('div', {
    staticClass: "lessons"
  }, [_vm._l((_vm.filtered), function(lesson) {
    return _c('div', {
      class: ['lesson', lesson.viewed ? 'is-viewed' : ''],
      on: {
        "click": function($event) {
          return _vm.learn(lesson)
        }
      }
    }, [(lesson.viewed) ? _c('icon', {
      staticClass: "status",
      attrs: {
        "name": "check"
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(lesson.name))])], 1)
  }), _vm._v(" "), (!_vm.filtered.length) ? _c('div', [_vm._v("\n                    " + _vm._s(_vm.$t('university.no_lessons')) + "\n                    "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showAll()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('university.show_all')))])]) : _vm._e()], 2) : _c('div', {
    staticClass: "lessons"
  }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.$t('text.loading')) + "\n                ")])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5363fec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/University.vue
// module id = 475
// module chunks = 234